import { createSlice } from "@reduxjs/toolkit";

const holidaySlice = createSlice({
    name:'holiday',
    initialState:{
        holiday:[]
    },
    reducers: {
        addHoliday : (state,action) => {
            state.holiday = [...state.holiday,action.payload]
        },
        // removeOccupation(){
        //     return state.occupation.filter((item)=> item.id != action.payload);
        // }
    }
});

export const { addHoliday } = holidaySlice.actions;
export default holidaySlice.reducer;